import React from "react"
import { IRow } from "./interface"
import { Component } from "./style"

const Row = ({
    display,
    children
}: IRow) => {

    return (
        <Component display={display}>
            { children }
        </Component>
    )
}

export default Row